export type IngestionStatus = 'PENDING' | 'INGESTED' | 'FAILED';

export type GoneReason = 'NOT_FOUND' | 'OUT_OF_SCOPE' | 'THIN';

export interface KnowledgeBaseItemResponse {
  id: number;
  name: string;
  description: string;
  createdDate: Date;
  nextReviewDate: string | null;
  ingestionStatus: IngestionStatus;
  ingestionError: string | null;
  enabled: boolean;
  websiteSourceId: number | null;
  sourceUrl: string | null;
  pageTitle: string | null;
  lastCrawledAt: string | null;
  goneSince: string | null;
  goneReason: GoneReason | null;
}

export const isCrawledItem = (item: KnowledgeBaseItemResponse): boolean =>
  item.websiteSourceId !== null && item.websiteSourceId !== undefined;
